export default __webpack_public_path__ + "static/media/elss-shark-banner-mob.474aec15.jpg";